// ====================================================

export const OMR_SHEET_PDF_URL =
  'https://storage.googleapis.com/schoolnet-cdn-images/omr_sheet/Geneo%20Assessment%2060Q%20OMR%20SHEET.pdf';

// ====================================================
